module.exports = __webpack_public_path__ + "static/media/network-wired.6ad6299c.svg";